import { render, staticRenderFns } from "./m12.vue?vue&type=template&id=756c8d4a&scoped=true"
import script from "./m12.vue?vue&type=script&lang=js"
export * from "./m12.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "756c8d4a",
  null
  
)

export default component.exports